import { createContext } from 'react';
import type { TeamDrawerContextValue } from './TeamDrawerContext.types';

export const TeamDrawerContext = createContext<TeamDrawerContextValue | null>(null);
